<template>
    <div class="wrap layout dashboard_wrap">
        <SideNav />
        <router-view />
        <InfoModal v-if="$store.getters.getInfoModal" />
        <RefreshPop v-if="$store.getters.getRefreshModal" />
    </div>

</template>

<script setup>

import SideNav from '@/components/Admin/SideNav.vue';
import InfoModal from '@/components/InfoModal.vue';
import RefreshPop from '@/components/RefreshPop.vue';

import { onMounted } from 'vue';


onMounted(async () => {
    const loadScript = (src) => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    };
    await loadScript('https://d3kx8o9mol3zjn.cloudfront.net/admin/js/common.js')
});
</script>

<style>
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/common.css";
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/style.css";
</style>